<template>
  <div class="company-user-item-department-bd">
    <div class="tip-box ub ub-xc" v-if="tip">
      <div style="padding: 2px 12px 0 16px;">
        <i class="icon icon-tishi"></i>
      </div>
      <div class="tip ub-f1">
        {{$t('cui_department_jrzzbmfzygkglxzdzzbmfzmxsysb')}}
      </div>
      <div style="padding: 0 20px;" @click="tip = false">
        <i class="icon icon-guanbi"></i>
      </div>
    </div>
    <div style="padding: 24px 24px 16px;">
      <div class="ub">
        <div class="ub-f1" style="margin-right: 16px">
          <search-input v-model="appKey" @input="filterTree" :placeholder="$t('cui_department_bmfzmc')" style="width: 100%;"></search-input>
        </div>
        <el-button round @click="addDepartment" :disabled="!organData.bizId">
          <i class="icon icon-tianjia"></i>
          {{ $t('cui_department_xin_zeng_bu_men') }}
        </el-button>
      </div>
      <div class="comp-tree">
        <el-tree
          ref="tree"
          node-key="bizId"
          :data="organTree"
          :props="{ children: 'children', label: 'bizName' }"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :check-strictly="true"
          :default-expanded-keys="expandedKeys"
          :filter-node-method="filterNode"
          default-expand-all
          highlight-current
        >
          <div class="tree-item ub-f1 ub ub-xc ub-sp" slot-scope="{ node }">
            <div>{{ node.label }}</div>
            <el-checkbox v-model="node.checked">{{ $t('com_join') }}</el-checkbox>
          </div>
        </el-tree>
      </div>
    </div>
    <div class="footer ub ub-xc ub-ae">
      <el-button @click="onCancel">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" v-if="type === 'add'" @click="onBack()">{{ $t('com_last_step') }}</el-button>
      <el-button type="warning" v-if="type === 'add'" @click="saveOrganUser()">{{ $t('cui_department_xia_yi_bu') }}</el-button>
      <el-button type="warning" v-if="type === 'edit'" @click="saveOrganUser()">{{ $t('com_save') }}</el-button>
    </div>
    <department-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getOrganTree"></department-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import departmentItemDialog from './department_item_dialog.vue';

// cui_department_jrzzbmfzygkglxzdzzbmfzmxsysb: 加入 组织/部门/分组，员工可管理选择的 组织/部门/分组 名下所有设备// cui_department_xin_zeng_bu_men: 新增部门// cui_department_xia_yi_bu: 下一步// cui_department_bmfzmc: 部门/分组名称// cui_department_xin_zeng_bu_men_1: 新增部门// cui_department_qxzjrdbm: 请选择加入的部门

export default {
  name: 'company_user_item_department',
  components: { departmentItemDialog },
  props: {
    type: String,
    userId: [String, Number]
  },
  data() {
    return {
      tip: true,
      organData: {},
      organTree: [],
      appKey: '',
      expandedKeys: ['1'],
      dialogVisible: false,
      dialogModel: {}
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_company_user_item_department');
    this.getOrganTree();
  },
  methods: {
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    onStep: function () {
      this.$emit('step', { name: 'organ' });
    },
    // 获取组织树
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree).then((res) => {
        this.organTree = [res.data];
        this.getUserOrganList();
      });
    },
    // 获取用户组织列表(不分页)
    getUserOrganList: function () {
      if (!this.userId) {
        return;
      }
      this.$getJSON(apis.UserDepartmentBindList, { userId: this.userId }).then((res) => {
        const checkedKeys = res.data;
        this.$refs.tree.setCheckedKeys(checkedKeys);
      });
    },
    // 选中部门
    handleNodeClick: function (data) {
      this.expandedKeys = [data.bizId];
      this.organData = data;
    },
    // 筛选组织
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.bizName.indexOf(value) !== -1;
    },
    // 搜索过滤事件
    filterTree: function (value) {
      this.expandedKeys = ['1'];
      this.$refs.tree.filter(value);
    },
    // 新增部门
    addDepartment: function () {
      this.dialogModel = {
        type: 'add',
        title: this.$t('cui_department_xin_zeng_bu_men_1'),
        bizId: this.organData.bizId,
        bizName: this.organData.bizName
      };
      this.dialogVisible = true;
    },
    // 保存用户部门
    saveOrganUser: function () {
      const selectDepartment = this.$refs.tree.getCheckedNodes();
      if (!selectDepartment.length) {
        this.$message.error(this.$t('cui_department_qxzjrdbm'));
        return;
      }
      const params = {
        userId: this.userId,
        orgDepartments: selectDepartment.map(t => ({
          bizId: t.bizId,
          bizType: t.bizType
        }))
      };
      this.$postJSON(apis.UserDepartmentBind, params).then(() => {
        if (this.type === 'add') {
          this.onStep();
        } else {
          this.$message({
            type: 'success',
            message: this.$t('com_handle_success')
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.company-user-item-department-bd {
  .tip-box {
    height: 52px;
    background: rgba(0, 160, 217, 0.08);
    .icon {
      font-size: 18px;
      cursor: pointer;
      color: $--color-primary;
    }
    .tip {
      color: $--color-text-secondary;
      font-size: 14px;
    }
  }
  .comp-tree {
    margin-top: 24px;
    height: 320px;
    overflow-y: auto;
    .el-tree-node__content > .el-tree-node__expand-icon {
      color: #495057;
      &.is-leaf {
        color: transparent;
      }
    }
    .el-tree-node__content {
      height: 40px;
    }
    .tree-item {
      font-size: 14px;
      padding-right: 8px;
      .el-checkbox__label {
        font-size: 12px;
      }
    }
  }
  .footer {
    height: 88px;
    padding: 0 24px;
    background: #f8f9fa;
  }
}
</style>
